import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {graphql} from 'gatsby'
import './ImageGrid.scss'

export default function ImageGrid({gallery}) {
	return(
		<div className="ImageGrid">
			{
				gallery &&
				gallery.map((item, i) => <div key={i} className="image"><GatsbyImage alt={item.altText} image={getImage(item.localFile.childImageSharp)} /></div>)
			}
		</div>
	)
}

export const query = graphql`
	fragment ImageGrid on WpPage_Layout_block_Layout_ImageGrid{
		fieldGroupName
		gallery {
			altText
			localFile {
				childImageSharp {
					gatsbyImageData(
						width: 200,
						height: 200,
						backgroundColor: "transparent",
						transformOptions: {cropFocus: CENTER, fit: CONTAIN}
					)
				}
			}
		}
	}
`